const lib = {
	selectors: {
		wrapper: '.logos',
		logoContent: '.logos__container',
	},
	classes: {
		animated: 'logos--animated',
	},
};

/**
 * Animated Logos
 */

const setAnimationDuration = (container) => {
	const animationTime = 45;
	const halfOfInnerLength = container.querySelector(lib.selectors.logoContent).clientWidth / 2;
	container.style.setProperty('--animation-time', `${halfOfInnerLength / animationTime}s`);
};

const initLogoAnimation = (container) => {
	container.setAttribute('data-animated', 'true');

	const logoContainer = container.querySelector(lib.selectors.logoContent);
	const logos = Array.from(logoContainer.children);

	logos.forEach((logo) => {
		const duplicatedItem = logo.cloneNode(true);
		duplicatedItem.setAttribute('aria-hidden', 'true');
		logoContainer.appendChild(duplicatedItem);
	});

	setAnimationDuration(container);
};

/**
 * Lazy Loading of Logo Masks
 */

const observer = new IntersectionObserver((entries, observer) => {
	entries.forEach((entry) => {
		const container = entry.target;
		// If the logo container is in the user's field of vision, load the logos.
		if (entry.isIntersecting) {
			// Iterate over each logo and set the mask image url.
			Array.from(container.querySelector(lib.selectors.logoContent).children).forEach((logo) => {
				const logoUrl = logo.getAttribute('data-logo');

				if (logo) {
					logo.removeAttribute('data-logo');
					logo.style.setProperty('--mask-img-url', `url(${logoUrl})`);
					logo.setAttribute('data-logo-loaded', 'true');
				}
			});

			observer.unobserve(container);
		}
	});
});

// Init
document.querySelectorAll(lib.selectors.wrapper).forEach((container) => {
	observer.observe(container);

	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	if (container.classList.contains(lib.classes.animated) && !prefersReducedMotion) {
		initLogoAnimation(container);
	}
});
